<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">로이터 메일 신청 리스트</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="clear mb-2">
                    <div class="form-group float-left clear w-100per">
                      <select v-model="filter.receiveFl" name="selYear"
                              class="form-control fl w-15">
                        <option value="">수신상태</option>
                        <option value="Y">수신</option>
                        <option value="N">수신거부</option>
                      </select>
                      <select v-model="filter.sField" name="selYear"
                              class="form-control fl w-15 ml-10">
                        <option value="">이름검색</option>
                        <option value="R_NAME">추천자</option>
                        <option value="T_NAME">추천받은사람</option>
                        <option value="T_EMAIL">e-mail</option>
                      </select>
                      <input v-model="filter.sText" type="text" class="form-control fl ml-10 w-10"
                             placeholder="검색명">
                      <label class="fl ml-10">
                        <input class="form-control" v-model="filter.sdate" type="date">
                      </label>
                      <label class="fl ml-10">
                        ~
                      </label>
                      <label class="fl ml-10">
                        <input class="form-control" v-model="filter.edate" type="date">
                      </label>
                      <button @click="selectReuters()" class="btn btn-primary fl ml-10">검색</button>
                    </div>
                  </div>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-bordered">
                      <tbody>
                      <tr align="center">
                        <th width="80px;">날짜</th>
                        <td v-for="(reuterTable, index) in reuterTables" :key="index">
                          {{ reuterTable.TODAY }}
                        </td>
                      </tr>
                      <tr align="center">
                        <th width="80px;">Open수</th>
                        <td v-for="(reuterTable, index) in reuterTables" :key="index">
                          {{ reuterTable.CNT }}
                        </td>
                      </tr>
                      <tr align="center">
                        <th width="80px;">배너클릭수</th>
                        <td v-for="(reuterTable, index) in reuterTables" :key="index">
                          {{ reuterTable.bc_cnt }}
                        </td>
                      </tr>
                      <tr align="center">
                        <th width="80px;">유입클릭수</th>
                        <td v-for="(reuterTable, index) in reuterTables" :key="index">
                          {{ reuterTable.lvcnt }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <table class="table table-bordered mt-2">
                      <tbody>
                      <tr align="center" height="25">
                        <th width="300" class="table02">추천받은 자 전체 인원 수</th>
                        <th width="150" class="table02">수신자 인원 수</th>
                        <th width="150" class="table02">수신거부 인원 수</th>
                        <th width="300" class="table02">사내(@carrotglobal.com)</th>
                        <th width="100" class="table02">그외</th>
                      </tr>
                      <tr align="center" height="25">
                        <td>{{ this.sendInfo.listen + this.sendInfo.notListen }}</td>
                        <td>{{ this.sendInfo.listen }}</td>
                        <td>{{ this.sendInfo.notListen }}</td>
                        <td>{{ this.sendInfo.carrot }}</td>
                        <td>{{ this.sendInfo.etc }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <button @click="selectReutersExcel" class="btn btn-primary fr ml-10 mb-3">엑셀</button>
                  <div class="table-responsive text-center" style="overflow-y: hidden;">
                    <table class="table table-bordered">
                      <tbody>
                      <tr align="center" height="25">
                        <th width="30" class="table02">
                          <input type="checkbox" value="Check All" id="all-select"
                                 @click="allSelectDailyWritingRewards"></th>
                        <th width="50" class="table02">No</th>
                        <th width="100" class="table02">보낸 사람</th>
                        <th>보낸 E-mail</th>
                        <th width="100" class="table02">받은사람</th>
                        <th>받는 E-mail</th>
                        <th width="100" class="table02">추천일</th>
                        <th width="10" class="table02">메일발송수</th>
                        <th width="10" class="table02">로이터수업</th>
                        <th width="100" class="table02">수신상태</th>
                      </tr>

                      <tr v-for="reuter in this.reuters" align="center" height="25">
                        <td><input class="check-rewards" type="checkbox" name="ckb[]" :value="reuter.seq" @click="checkCheckbox"></td>
                        <td>{{ reuter.seq }}</td>
                        <td>{{ reuter.r_name }}</td>
                        <td>{{ reuter.r_email }}</td>
                        <td>{{ reuter.t_name }}</td>
                        <td>{{ reuter.t_email }}</td>
                        <td>{{ reuter.createdate }}</td>
                        <td>{{ reuter.cnt }}</td>
                        <td>{{ reuter.rcnt }}</td>
                        <td>{{ reuter.receive_fl }}</td>
                      </tr>
                      <tr v-if="this.reuters.length <= 0" >
                        <td colspan="10">
                          검색결과가 존재하지 않습니다.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="reuters.length !== 0" style="padding-left:40%; padding-top:20px;">
                    <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                              :click-handler="clickCallback" :prev-text="'Prev'"
                              :next-text="'Next'" :container-class="'pagination'"
                              :page-class="'page-link'">
                    </paginate>
                  </div>
                  <button @click="doDelete" class="btn fl btn-primary">삭제하기</button>
                  <button @click="doWithout" class="btn fr btn-primary">수신거부 등록하기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/commons/incMenu'
import Paginate from 'vuejs-paginate';

export default {
  name: 'Reuters',
  components: {
    Menu,
    Paginate
  },
  data () {
    return {
      lastpage: 0,
      reuters: [
        {
          no: 60,
          isSelect: false,
          isPlatform: '사용',
          isTopic: 'Y',
          isMain: 'OK',
          sendImoocDate: '2021-01-25',
          sendMailDate: '2021-01-25',
          code: 'CKR130947',
          date: '2021-01-22',
          title: 'Norwegian Air gets backing for survival plan',
          tutor: 'Joanne Jang(내부 직원)',
          create_date: '2021-01-22'
        }
      ],
      reuterTables: [],
      sendInfo: [],
      tutors: [],
      videos: [],
      filter: {
        receiveFl: '',
        sdate: this.$moment().startOf('year').format('YYYY-MM-DD'),
        edate: this.$moment().format('YYYY-MM-DD'),
        sField: 'R_NAME',
        sText: '',
      },
      years: [],
      months: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ]
    }
  },
  mounted () {
    this.selectReuters()
    this.selectReuterTables()
    this.selectReuterSend()
  },
  methods: {
    selectReutersExcel: function () {
      const url = '/v1/api/admin/reuters-excel'
      const params = this.getParams({
        receiveFl: this.filter.receiveFl
        , sdate: this.filter.sdate
        , edate: this.filter.edate
        , sField: this.filter.sField
        , sText: this.filter.sText
        , page: this.filter.page
      })

      const config = {
        params,
        url : url,
        responseType: 'blob'
      }

      this.axios.get(url, config)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reuters_excel.' + '.xlsx');
        document.body.appendChild(link);
        link.click();
        console.log(link);
      });

    },
    doCancelAll: function () {
      document.querySelector("#all-select").checked = false
      for (const element of document.querySelectorAll(".check-rewards")) {
        element.checked = false;
      }
    },
    doDelete: function () {
      let deleteList = []
      let checkReward = document.querySelectorAll(".check-rewards");
      for (const element of checkReward) {
        if(element.checked){
          deleteList.push(element.value)
        }
      }
      if(deleteList.length > 0){
        const url = '/v1/api/admin/reuters-delete'
        this.axios.post(url, deleteList)
        .then(res => {
          if(res.data.err === 0){
            alert('삭제처리가 완료되었습니다.')
            this.selectReuters()
            this.selectReuterTables()
            this.doCancelAll()
          }else{
            alert('삭제처리에 실패했습니다.')
          }
        }).catch(err => {
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
        })
      }else{
        alert('삭제할 사람을 선택해주세요.')
      }
    },
    doWithout: function () {
      let withoutList = []
      let checkReward = document.querySelectorAll(".check-rewards");
      for (const element of checkReward) {
        if(element.checked){
          withoutList.push(element.value)
        }
      }

      if(withoutList.length > 0){
        const url = '/v1/api/admin/reuters-without'
        this.axios.post(url, withoutList)
        .then(res => {
          if(res.data.err === 0){
            alert('수신거부 등록이 완료되었습니다.')
            this.selectReuters()
            this.selectReuterTables()
            this.doCancelAll()
          }else{
            alert('수신거부 등록에 실패했습니다.')
          }
        }).catch(err => {
          if (err.response.data.path === '/login/msg') {
            alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
            this.$router.push('/login')
          } else {
            alert('관리자에게 문의하세요')
          }
        })
      }else{
        alert('수신거부할 사람을 선택해주세요.')
      }
    },
    checkCheckbox: function () {
      let checkReward = document.querySelectorAll(".check-rewards");
      let checkNum = 0;
      for (const element of checkReward) {
        if(element.checked){
          checkNum++;
        }
      }
      document.querySelector("#all-select").checked = (checkNum === checkReward.length);
    },
    allSelectDailyWritingRewards: function () {
      let checked = document.querySelector("#all-select").checked;
      for (const element of document.querySelectorAll(".check-rewards")) {
        element.checked = checked;
      }
    },
    clickCallback: function (pageNum) {
      this.filter.page = pageNum
      this.selectReuters()
      this.doCancelAll()
    },
    selectReuterSend: function () {
      const url = '/v1/api/admin/reuters-send'
      const params = this.getParams({})
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        console.log(res)
        if (res.data.err === 0) {
          this.sendInfo = res.data.sendInfo
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },
    selectReuterTables: function () {
      const url = '/v1/api/admin/reuters-table'
      const params = this.getParams({})
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          this.reuterTables = res.data.table
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },
    selectReuters: function () {
      const url = '/v1/api/admin/reuters'
      const params = this.getParams({
        receiveFl: this.filter.receiveFl
        , sdate: this.filter.sdate
        , edate: this.filter.edate
        , sField: this.filter.sField
        , sText: this.filter.sText
        , page: this.filter.page
      })
      this.axios.get(url, {
        params: params
      })
      .then(res => {
        if (res.data.err === 0) {
          console.log(res)
          this.reuters = res.data.result.value
          this.lastpage = res.data.result.lastPage
        }
      }).catch(err => {
        if (err.response.data.path === '/login/msg') {
          alert('세션이 끊어졌습니다. 로그인 페이지로 이동합니다.')
          this.$router.push('/login')
        } else {
          alert('관리자에게 문의하세요')
        }
      })
    },
  }
}
</script>

<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";
</style>



// WEBPACK FOOTER //
// src/pages/reuters/reuters.vue